import { styled } from '@mui/material/styles'

import { CheckboxWrapper } from '../wrapper'

export const Checkbox = styled(CheckboxWrapper)(() => ({
  borderRadius: '0.5rem',
}))
